import axios from "axios";
import apiService from "./apiService";

export default {
  async getCoordinates(address: string): Promise<google.maps.GeocoderResult> {
    const res = await axios.get(apiService.map.coordinates(address));
    return res.data.results[0] as google.maps.GeocoderResult;
  },
};
